import { get } from 'lodash';

import { Embed } from '@hivebrite/design-system/Embed';
import type { EmbedComponentProps } from '@hivebrite/design-system/Embed';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

// Fake function to add necessary translations for DS/Embed component.
export const translations = ({ providerName, title }) => [
  s__('Embed|Show third-party media?'),
  s__(
    'Embed|This media may use cookies and has its own privacy policy. You always can change your choice in privacy settings of your account.',
  ),
  s__('Embed|Always for %{providerName}').i__({ providerName }),
  s__('Embed|Allow once'),
  s__('Embed|Remove embed preview of %{title}.').i__({ title }),
  s__('Embed|Start the video preview'),
];

const Wrapper = (props: EmbedComponentProps) => {
  const { currentNetwork } = useDefaultAppContexts();

  // Do not use destructuring. In some cases BO.currentNetwork
  // may be undefined for awhile.
  const displayThirdPartyConsent = get(
    currentNetwork,
    'features.cookies.config.display_third_party_consent',
  );

  return <Embed {...props} withUserConsent={displayThirdPartyConsent} />;
};

export default Wrapper;
